import React, {Dispatch, FC, SetStateAction, useCallback, useContext, useMemo} from 'react';
import {Drawer} from 'components-lib';
import {AddResourcesActionButtons, AddSessionAdditionalContent, AddSessionResourcesForm} from '..';
import {FormContext} from 'forms/formik/FormContextProvider';

interface IAddSessionResourcesProps {
  id: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const AddSessionResources: FC<IAddSessionResourcesProps> = ({id, isOpen, setIsOpen}) => {
  const {formikFormRef, setIsDirty, isDirty, submitFormikForm, resetIsDirty} = useContext(FormContext);

  const submitFormClickHandler = useCallback(() => formikFormRef?.current && submitFormikForm(), [
    formikFormRef,
    submitFormikForm,
  ]);

  const closeDrawerClickHandler = useCallback(() => setIsOpen(false), [setIsOpen]);

  const addResourcesActionButtons = useMemo(
    () => (
      <AddResourcesActionButtons
        closeClickHandler={closeDrawerClickHandler}
        submitClickHandler={submitFormClickHandler}
        disableSubmit={!isDirty}
      />
    ),
    [closeDrawerClickHandler, submitFormClickHandler, isDirty]
  );

  return (
    <Drawer
      title="Add Resources"
      confirmButtonTitle="Add Resources"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      actionButtons={addResourcesActionButtons}
    >
      <AddSessionResourcesForm
        id={id}
        formikFormRef={formikFormRef}
        resetIsDirty={resetIsDirty}
        closeDrawerClickHandler={closeDrawerClickHandler}
      >
        <AddSessionAdditionalContent isDirty={isDirty} setIsDirtyCallback={setIsDirty} />
      </AddSessionResourcesForm>
    </Drawer>
  );
};
